const segmentWriteKey = () => process.env.SEGMENT_WRITE_KEY;
export default segmentWriteKey;
